<template>
  <div class="add_plan_box dark-theme">
    <div class="plan_title">{{ type == "add" ? "添加" : "编辑" }}训练</div>
    <div class="plan_content">
      <el-form :model="schedule_form" ref="scheduleRule" label-width="120px">
        <el-form-item
          label="日程标题"
          prop="scheduleName"
          :rules="[{ required: true, message: '日程标题' }]"
        >
          <a-input
            size="large"
            v-model="schedule_form.scheduleName"
            placeholder="日期标题"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="日程开始时间"
          prop="startTime"
          :rules="[{ required: true, message: '请选择日程开始时间' }]"
        >
          <el-time-picker
            v-model="schedule_form.startTime"
            format="HH:mm"
            placeholder="请选择日程开始时间"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item
          label="日程结束时间"
          prop="endTime"
          :rules="[{ required: true, message: '请选择日程结束时间' }]"
        >
          <el-time-picker
            v-model="schedule_form.endTime"
            format="HH:mm"
            placeholder="请选择日程结束时间"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item
          label="参与人员"
          :rules="[{ required: false, message: '选择人员' }]"
          v-if="[3, 4].includes(userType)"
        >
          <div class="sporter_list flex-row flexWrapTree">
            <div
              class="sporter_item flex-column align-center"
              v-for="memberItem in cyShow"
              :key="memberItem.id"
              :title="memberItem.name"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="48" :src="memberItem.headImageUrl" />
              </div>
              <span class="sporter_name">{{ memberItem.name }}</span>
            </div>
            <div
              class="sporter_item flex-column align-center pointer elIconPlus"
              @click="editSporter(1)"
            >
              <i class="el-icon-circle-plus-outline"></i>
              <span class="upload_name">选择参与人员</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :label="[3, 4].includes(userType) ? '日程地点' : '训练地点'"
          :rules="[{ required: false, message: '请选择地点' }]"
        >
          <div class="addressMain">
            <div class="result">
              <div class="result_name">{{ schedule_form.addressName }}</div>
              <div class="result_info">
                {{ schedule_form.name }}{{ schedule_form.addressDetail }}
              </div>
            </div>
            <div class="line">
              <div class="btn btn_address" @click="selectAddressList">
                <i class="el-icon-location"></i>切换地址
              </div>
              <div class="btn btn_add" @click="addAddress">
                <i class="el-icon-circle-plus"></i>添加地址
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :label="[3, 4].includes(userType) ? '备注信息' : '训练内容'"
        >
          <a-textarea
            v-model="schedule_form.remark"
            placeholder="输入内容"
            :show-count="true"
            :rows="3"
            :maxlength="100"
          />
        </el-form-item>
        <el-form-item
          label="上传附件"
          :rules="[{ required: false, message: '请上传附件' }]"
        >
          <a-upload
            :file-list="schedule_form.fileList"
            name="file"
            :multiple="false"
            :max-count="1"
            :action="`${http}/api/file/uploadOss`"
            :headers="headers"
            @change="handleChange"
            :defaultFileList="schedule_form.fileList"
            accept=".rar, .zip, .doc, .docx, .pdf"
            :beforeUpload="beforeUpload"
          >
            <a-button class="upload_btn">
              <upload-outlined></upload-outlined>
              上传文件
            </a-button>
          </a-upload>
          <p class="upload_tip">
            支持格式：rar.zip.doc.docx.pdf，单个文件不能超过20MB
          </p>
        </el-form-item>
        <el-form-item
          label="同步日程人员"
          :rules="[{ required: false, message: '选择人员' }]"
        >
          <div class="sporter_list flex-row flexWrapTree">
            <div
              class="sporter_item flex-column align-center"
              v-for="syncItem in tbShow"
              :key="syncItem.id"
              :title="syncItem.name"
            >
              <div class="avatar_box flex-row align-center justify-center">
                <a-avatar :size="48" :src="syncItem.headImageUrl" />
              </div>
              <span class="sporter_name">{{ syncItem.name }}</span>
            </div>
            <div
              class="sporter_item flex-column align-center pointer elIconPlus"
              @click="editSporter(2)"
            >
              <i class="el-icon-circle-plus-outline"></i>
              <span class="upload_name">选择教练员</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitSchedule('submit')"
            >提交</el-button
          >
          <el-button @click="operation('reset')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新建日程-选择参与人员 -->
    <!-- <treeModal
      :dataList="memberList_cy"
      :keys="cyCheck"
      :peoples="cyShow"
      :modalTitle="treeTitle"
      :modalVisible="cyVisible"
      @transmit="getResult"
    ></treeModal> -->

    <!-- 新建日程-同步日程人员 -->
    <!-- <treeModal
      :dataList="memberList_tb"
      :keys="tbCheck"
      :peoples="tbShow"
      :modalTitle="treeTitle"
      :modalVisible="tbVisible"
      @transmit="getResult"
    ></treeModal> -->

    <!-- 添加新地点-start -->
    <el-dialog title="添加地点" :visible.sync="addAddressVisible" width="577px">
      <el-form :model="newAddress" ref="newAddressRef" label-width="120px">
        <el-form-item
          label="地点名称"
          prop="addressName"
          :rules="[{ required: true, message: '请输入地点名称' }]"
        >
          <a-input
            size="large"
            v-model="newAddress.addressName"
            autocomplete="off"
            placeholder="请输入地点名称"
          />
        </el-form-item>
        <el-form-item
          label="省市区"
          prop="code"
          :rules="[{ required: true, message: '请选择省市区' }]"
        >
          <a-cascader
            v-model="newAddress.code"
            :fieldNames="fileladName"
            :options="jsonRibbit.areaList"
            :onChange="selectName"
            placeholder="请选择省市区"
          />
        </el-form-item>
        <el-form-item
          label="详细地址"
          prop="addressDetail"
          :rules="[{ required: true, message: '请输入详细地址' }]"
        >
          <a-input
            size="large"
            v-model="newAddress.addressDetail"
            autocomplete="off"
            placeholder="请输入详细地址"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addAddressVisible = false">取 消</el-button>
        <el-button type="primary" @click="subAddAddress">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加新地点-end -->

    <!-- 选择地点 -->

    <el-dialog title="切换地点" :visible.sync="addressVisible">
      <div class="modal_content">
        <div class="address_box">
          <div
            class="address_list"
            v-if="addressList && addressList.length > 0"
          >
            <div
              class="address_item"
              :class="{ address_item_active: hall_cur.id == item.id }"
              v-for="(item, index) in addressList"
              :key="index"
              @click="selectHallAddress(item)"
            >
              <span class="common_tip" v-if="item.useNum > 3">常用</span>
              <div class="address_top">{{ item.addressName }}</div>
              <div class="address_middle">
                {{ item.name }} {{ item.addressDetail }}
              </div>
            </div>
          </div>
          <a-empty v-else />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addressVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveHallAddress">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
// import AdministrativeArea from "@/components/administrativeArea/administrativeArea.vue";
import { message } from "ant-design-vue";
// import MulCalendar from "@/components/mulCalendar/mulCalender.vue";
// import treeModal from "../components/treeModal.vue";

export default {
  // components: { treeModal },
  data() {
    return {
      addressVisible: false,
      addAddressVisible: false,
      scheduleOperaType: "add",
      treeTitle: "",
      tbShow: [],
      cyShow: [],
      cyCheck: [],
      tbCheck: [],
      addressList: [],
      jsonRibbit: [],
      cyVisible: false,
      userType: this.$store.state.user.user.type, //用户类型
      userId: this.$store.state.user.user.userId, //用户id
      hall_cur: {},
      schedule_form: {
        // scheduleName: undefined,
        // startTime: '',
        // endTime: '',
        // sportsHallId: undefined,
        // remark: undefined,
        // syncList: [],
        // partInList: [],
        fileList: [],
        // date: undefined,
      },
      headers: {
        system: 1,
      },
      newAddress: {
        addressName: null,
        addressDetail: null,
        code: [],
        name: [],
      },
    };
  },
  created() {
    this.getMember_cy();
    this.getMember_tb();
  },
  methods: {
    getMember_cy() {
      this.$axios.get("/sys/member/scheduleMember", {}).then((res) => {
        if (res.code == 200) {
          this.memberList_cy = res.data;
        }
      });
    },
    getMember_tb() {
      this.$axios.get("/sys/member/scheduleSynMember", {}).then((res) => {
        if (res.code == 200) {
          this.memberList_tb = res.data;
        }
      });
    },
    // 添加运动员--添加或编辑
    editSporter(type) {
      this.treeType = type;
      if (type == 1) {
        this.cyVisible = true;
        this.treeTitle = "选择参与人员";
      }
      if (type == 2) {
        this.tbVisible = true;
        this.treeTitle = "选择同步人员";
      }
    },
    getResult(res) {
      // console.log(res.length);
      if (Array.isArray(res)) {
        if (this.treeType == 1) {
          this.cyShow = res;
          this.cyCheck = res.map((i) => {
            return i.id;
          });
        }
        if (this.treeType == 2) {
          this.tbShow = res;
          this.tbCheck = res.map((i) => {
            return i.id;
          });
        }
      }
      if (this.treeType == 1) this.cyVisible = false;
      if (this.treeType == 2) this.tbVisible = false;
    },
    // 新建日程-日程地点-start
    selectAddressList() {
      this.$axios.get("/api/drill/findAddressByMemberId").then((res) => {
        if (res.code == 200) {
          console.log(res.data);
          this.addressList = res.data;
          this.addressVisible = true;
        }
      });
    },
    addAddress() {
      this.addAddressVisible = true;
    },
    subAddAddress() {
      this.$refs.newAddressRef
        .validate(["addressName", "code", "addressDetail"])
        .then(() => {
          this.subAddressApi();
        })
        .catch(() => {
          console.log("校验不通过");
        });
    },
    subAddressApi() {
      let param = this.newAddress;
      param.code = param.code.join(",");
      param.name = param.name.join("/");
      this.$axios.post("/api/drill/edit", param).then((res) => {
        if (res.code == 200) {
          this.$message.success("地点添加成功");
          this.addAddressVisible = false;
          param = {};
          this.newAddress = {
            name: [],
            code: [],
            addressName: null,
            addressDetail: null,
          };
          setTimeout(() => {
            this.selectAddressList();
          }, 1000);
        }
      });
    },
    selectHallAddress(item) {
      console.log("训练地点");
      console.log(item);
      this.hall_cur = item;
    },
    saveHallAddress() {
      if (!this.hall_cur.id) {
        message.error("请选择地点");
        return;
      }
      this.schedule_form.addressId = this.hall_cur.id;
      this.schedule_form.name = this.hall_cur.name;
      this.schedule_form.addressName = this.hall_cur.addressName;
      this.schedule_form.addressDetail = this.hall_cur.addressDetail;
      this.addressVisible = false;
    },
    beforeUpload(file, fileList) {
      //判断是否小于20M
      let isLt20M = file.size < 1024 * 1024 * 20;
      if (!isLt20M) {
        //将fileList中本次file文件删掉
        fileList.splice(fileList.indexOf(file), 1);
        this.$message.error("所选文件单个超过20M");
        return false;
      }
      this.file = file;
      return true;
    },
    handleChange(info) {
      console.log(info, this.schedule_form.fileList, "-------==");
      if (info.file.status != undefined && info.file.status == "done") {
        this.schedule_file = [...this.schedule_file];
        if (info.file.response && info.file.response.code == 200) {
          let obj = {
            fileName: info.file.response.data.fileName,
            filePath: info.file.response.data.url,
            fileSize: info.file.response.data.fileSize,
            id: info.file.uid, //删除的时候用
          };
          this.schedule_file.push(obj);
        }
        console.log(this.schedule_file);
        if (
          info.file.response &&
          info.file.response.code != 200 &&
          info.fileList.length <= 0
        ) {
          this.schedule_file = [];
        }
      }
      if (info.file.status != undefined && info.file.status == "removed") {
        this.schedule_file = this.schedule_file.filter(
          (res) => res.id != info.file.uid,
        );
      }
    },
    reset(form) {
      for (let key in form) {
        form[key] = null;
      }
    },
    submitSchedule() {
      this.$refs.scheduleRule
        .validate(["scheduleName", "startTime", "endTime", "date"])
        .then(() => {
          let syncArr = [];
          if (
            this.schedule_form.syncList &&
            this.schedule_form.syncList.length > 0
          ) {
            this.schedule_form.syncList.map((item) => {
              syncArr.push({ memberId: item });
            });
          }
          let partInArr = [];
          if (
            this.schedule_form.partInList &&
            this.schedule_form.partInList.length > 0
          ) {
            this.schedule_form.partInList.map((item) => {
              partInArr.push({ memberId: item });
            });
          }
          // 对上传的附件数据进行操作
          let files = [];
          if (this.schedule_file && this.schedule_file.length > 0) {
            this.schedule_file.map((item) => {
              let obj = {
                fileName: item.fileName,
                filePath: item.filePath,
                fileSize: item.fileSize,
              };
              files.push(obj);
            });
          }

          // 参与人员
          let partin_arr = [];
          if (this.cyShow && this.cyShow.length > 0) {
            this.cyShow.map((item) => {
              partin_arr.push({ memberId: item.id });
            });
          }
          // 同步日程人员
          let sync_arr = [];
          if (this.tbShow && this.tbShow.length > 0) {
            this.tbShow.map((item) => {
              sync_arr.push({ memberId: item.id });
            });
          }

          // 这里把日期和时间分开，前端再拼接上去，防止运营人员看不懂---研究生运营妹子看不懂
          let dateStr = moment(this.schedule_form.date).format("yyyy-MM-DD");
          let startStr = moment(this.schedule_form.startTime).format("HH:mm");
          let endStr = moment(this.schedule_form.endTime).format("HH:mm");
          let startTimeStr = dateStr + " " + startStr;
          let endTimeStr = dateStr + " " + endStr;
          let param = {
            scheduleName: this.schedule_form.scheduleName,
            addressId: this.schedule_form.addressId
              ? this.schedule_form.addressId
              : "",
            startTime: new Date(startTimeStr).getTime(),
            endTime: new Date(endTimeStr).getTime(),
            sportsHallId: this.schedule_form.sportsHallId
              ? this.schedule_form.sportsHallId
              : "",
            remark: this.schedule_form.remark ? this.schedule_form.remark : "",
            syncList: sync_arr,
            partInList: partin_arr,
            fileInfoSaveDTOS: files,
            type: 2,
          };
          let url;
          console.log(param);
          if (this.scheduleOperaType == "edit") {
            //编辑日程
            url = "/sys/schedule/edit";
            param.id = this.schedule_form.id;
          } else {
            url = "/sys/schedule/add";
          }
          this.$axios.post(url, param).then((res) => {
            if (res.code == 200) {
              this.schedule_visible = false;
              this.reset(this.schedule_form);
              this.getSchedule();
            }
          });
        })
        .catch(() => {
          console.log("校验不通过");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.add_plan_box {
  background: #141937;
  padding: 30px;
  font-size: 14px;

  .plan_title {
    margin: 10px 0 20px 3px;
  }

  .plan_content {
    background: #1c2242;
    padding: 50px 100px;

    .ant-calendar-picker {
      width: 50% !important;
    }

    .btn_list {
      .btn_item {
        padding: 3px 35px;
        border-radius: 4px;
        background-color: #282f54;
        border: 1px solid transparent;
        color: #ccc;
        font-size: 15px;
        margin-right: 20px;

        &:last-child {
          margin-right: 0;
        }
      }

      .select_btn {
        color: #1890ff;
        border: 1px solid rgba(24, 144, 255, 0.8);
        background-color: transparent;
      }
    }
    .device_box {
      .device_btn {
        margin-bottom: 35px;
      }

      .device_list {
        .device_item {
          margin-bottom: 30px;

          &:last-child {
            margin-bottom: 0;
          }

          .device_name {
            color: #fff;
            margin-left: 16px;
            width: 200px;
            margin-right: 10px;
          }
        }
      }
    }

    .action_header {
      padding-left: 8px;

      .add_btn {
        color: #1890ff;

        .icon {
          font-size: 17px;
        }
      }
    }

    .action_box {
      .action_item {
        margin-bottom: 24px;
        padding: 30px 24px;
        background: #282f54;
        border-radius: 4px;

        .exciting_list {
          padding-left: 12px;

          .exciting_item {
            margin-bottom: 40px;

            &:last-child {
              margin-bottom: 0;
            }

            .exciting_title {
              margin-bottom: 16px;

              .exciting_edit_btn {
                margin-right: 8px;
              }
            }

            .exciting_content {
              color: #bcbcbc;
            }
          }
        }
      }
    }

    .sports_hall,
    .drill_date {
      width: 50%;
      height: 40px;
      line-height: 40px;
      background: #282f54;
      border-radius: 4px;
      color: #d9d9d9;
      padding-left: 11px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .drill_date_box {
      position: relative;

      .date_component {
        position: absolute;
        top: 40px;
        height: 550px;
        overflow: hidden;
        z-index: 20;
        border: 1px solid #282f54;
        color: #fff;
        background: #1c2242;

        .footer {
          padding: 20px;
        }
      }
    }

    .upload_box {
      .tips {
        color: #999999;
        margin-top: 23px;
      }
    }

    .line-btn {
      .icon {
        color: #197ad9 !important;
      }
    }

    .delete_btn {
      color: #f21753 !important;
      border-color: #f21753 !important;

      .icon {
        color: #f21753 !important;
      }
    }

    .color_f {
      color: #fff;
    }
  }
}

.sporter_content_box {
  height: 600px;
  overflow: auto;
}

.modal_content {
  .device_box {
    .title {
      color: #ffffff;
      font-size: 16px;
      padding-left: 8px;
      border-left: 4px solid #1890ff;
      margin-bottom: 40px;
    }

    .device_item {
      margin-right: 50px;
      margin-bottom: 20px;

      &:last-child {
        margin-right: 0;
      }

      .device_img {
        margin-left: 16px;
      }
    }
  }

  .add_sporter_box {
    .title {
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      padding-left: 8px;
      border-left: 4px solid #1890ff;
      margin-bottom: 40px;
    }

    .sporter_content {
      .left {
        width: 45%;

        .search {
          margin-bottom: 24px;

          /deep/.ant-input-search-icon {
            color: #fff;
          }
        }

        .sporter_list {
          height: 450px;
          background: #282f54;
          padding: 24px;
          overflow: auto;

          /deep/.ant-tree li .ant-tree-node-content-wrapper,
          /deep/.ant-checkbox-wrapper {
            color: #fff;
          }

          /deep/.ant-checkbox-wrapper {
            margin-left: 8px;
          }
        }
      }

      .right {
        width: 45%;
        padding: 24px;
        background: #282f54;

        .header {
          .left {
            font-size: 14px;
            color: #cdcdcd;
            width: auto;
          }

          .right {
            font-size: 16px;
            color: #1890ff;
            padding: 0;
            width: auto;
          }
        }

        .selected_list {
          .selected_item {
            padding: 8px 0;
            color: #fff;
          }
        }
      }
    }
  }

  .address_box {
    color: #fff;

    .address_header {
      margin-bottom: 38px;

      .hall_search {
        margin-left: 7px;

        /deep/.ant-input-search-icon {
          color: #fff;
        }
      }
    }

    .address_list {
      height: 400px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 0;
      }

      .address_item {
        padding: 13px 20px 8px 20px;
        background: #282f54;
        margin-bottom: 16px;
        border-radius: 4px;
        position: relative;
        border: 1px solid #282f54;

        .common_tip {
          font-size: 12px;
          color: #ffffff;
          padding: 4px 12px;
          background: #fa6ba4;
          border-radius: 4px 4px 0px 4px;
          position: absolute;
          top: 0;
          right: 0;
        }

        .address_top {
          font-size: 15px;
        }

        .address_middle {
          font-size: 12px;
          color: #bcbcbc;
          margin-top: 10px;
        }

        .address_bottom {
          font-size: 12px;
          color: #bcbcbc;
          border-top: 1px solid #232948;
          padding-top: 8px;
        }
      }

      .address_item_active {
        border-color: #1890ff;
      }
    }
  }

  .change_type_text {
    color: #fff;
    flex: 1;
    font-size: 12px;
    margin-left: 10px;
  }
}

.select_hall {
  .ant-modal-footer {
    .hall_name {
      width: 193px;
      height: 40px;
      background: #282f54;
      border-radius: 4px;
      text-align: left;
      line-height: 40px;
      padding-left: 16px;
    }
  }
}

/deep/.ant-checkbox-wrapper {
  color: #fff;
}

/deep/.ant-time-picker-icon .ant-time-picker-clock-icon,
/deep/.ant-time-picker-clear .ant-time-picker-clock-icon {
  color: #fff;
}

.addressMain {
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 5px;
  max-width: 290px;

  .result {
    margin-bottom: 20px;

    .result_name {
      font-size: 15px;
      color: #fff;
    }

    .result_info {
      color: #fff;
    }
  }

  .line {
    display: flex;

    .btn {
      color: rgba(255, 255, 255, 0.6);
      border: 1px solid rgba(255, 255, 255, 0.6);
      padding: 5px 10px;
      border-radius: 3px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        margin-right: 5px;
      }
    }

    .btn:hover {
      border: 1px solid rgba(255, 255, 255, 1);
      color: rgba(255, 255, 255, 1);
    }

    .btn_address {
    }

    .btn_add {
    }
  }
}
</style>
